<script lang="ts">
    import type {CssSize} from 'shared/ui-widgets/types';
    import {fly} from 'svelte/transition';

    export let id: string | null = null;
    export let additionalClasses = '';
    export let isBootstrapContainer = true;
    export let gap: CssSize = '30px';
    export let topMargin: CssSize = '40px';

    const pageFlyInParams = {y: 15, duration: 250};
</script>

<div id="{id}"
     in:fly={pageFlyInParams}
     class:container={isBootstrapContainer}
     class="kp-generic-page-container {additionalClasses}"
     style:--margin-top="{topMargin}"
     style:--gap="{gap ?? '0px'}">

    <slot/>
</div>

<style lang="less">
    .kp-generic-page-container {
        display: flex;
        flex-direction: column;
        gap: var(--gap);
        margin-top: var(--margin-top);

        // We don't want default Bootstrap's before and after elements
        &.container::after,
        &.container::before {
            display: none;
        }
    }

    :global {
        .kp-generic-page-container .panel {
            margin-bottom: 0;
        }
    }
</style>